export default {
  steps: {
    on: 'Pe',
    step: 'pasul',
    gotoStep: 'Mergeți la pas',
    instruction: 'Instrucțiuni',
  }
}
